import type { VeeValidateLocale } from "@/locales/fr/vee-validate";

const veeValidateLocale: VeeValidateLocale = {
  veeValidate: {
    code: "en",
    messages: {
      _default: "The field is not valid",
      alpha: "The field may only contain alphabetic characters",
      alpha_num: "The field may only contain alpha-numeric characters",
      alpha_dash: "The field may contain alpha-numeric characters as well as dashes and underscores",
      alpha_spaces: "The field may only contain alphabetic characters as well as spaces",
      between: "The field must be between {min} and {max}",
      confirmed: "The field confirmation does not match",
      digits: "The field must be numeric and exactly contain {length} digits",
      dimensions: "The field must be {width} pixels by {height} pixels",
      email: "The field must be a valid email",
      not_one_of: "The field is not a valid value",
      ext: "The field is not a valid file",
      image: "The field must be an image",
      integer: "The field must be an integer",
      length: "The field must be {length} long",
      max_value: "The field must be {max} or less",
      max: "The field may not be greater than {length} characters",
      mimes: "The field must have a valid file type",
      min_value: "The field must be {min} or more",
      min: "The field must be at least {length} characters",
      numeric: "The field may only contain numeric characters",
      one_of: "The field is not a valid value",
      one_of_values: "The field must be one of the following values: {values}",
      not_one_of_values: "The field must not be one of the following values: {values}",
      regex: "The field format is invalid",
      required_if: "The field is required when {target} has this value",
      required: "The field is required",
      size: "The field size must be less than {size}KB",
      url: "The field is not a valid URL",
      nameConjunction: "Please enter the contact details for only one person",
    },
  },
};

export default veeValidateLocale;
